"use client";

import { getPublicCategoriesAction } from "@/server/catalog/actions";

import { listMyCategoriesAction } from "@/server/me/actions";
import { useQuery } from "@tanstack/react-query";
import type { CategoryItem } from "@/types/category";
import { catalogKeys, type CatalogScope } from "./keys";

/**
 * Kategori katalog (personal `me` / `public`) — konsolidasi pemakaian lama
 * ber-key inline `["categories", ...]`: PopularCategory (scope "me" +
 * initialData seed server) dan AllExamsSection (switch me|public).
 * Invalidasi massal: `queryClient.invalidateQueries({ queryKey: catalogKeys.all })`.
 */
export function useCatalogCategories<T = CategoryItem>(
  scope: CatalogScope,
  opts?: { initialData?: T[]; staleTime?: number; enabled?: boolean },
) {
  return useQuery({
    queryKey: catalogKeys.categories(scope),
    queryFn: async () => {
      const r =
        scope === "me"
          ? await listMyCategoriesAction()
          : await getPublicCategoriesAction();
      if (!r.ok) throw new Error(r.error.message);
      return r.data as T[];
    },
    initialData: opts?.initialData,
    enabled: opts?.enabled,
    staleTime: opts?.staleTime ?? 0,
  });
}
